import { Customer } from "./Customer";

export interface CustomerSummary extends Customer {
  lastProjectDate?: string;
  orderCount?: number;
}

export function toCustomer(customerSummary: CustomerSummary): Customer {
  return {
    id: customerSummary.id,
    lastname: customerSummary.lastname,
    firstname: customerSummary.firstname,
    phoneNumber1: customerSummary.phoneNumber1,
    vatNumber: customerSummary.vatNumber,
    companyName: customerSummary.companyName,
    billingAddress: customerSummary.billingAddress,
    customerType: customerSummary.customerType,
    email: customerSummary.email,
  };
}
